import { observable, computed, action } from "mobx";
import checkAuth from "../Utils/checkAuth";
import CookiesHandler from "../Utils/CookiesHandler";


export default class AppHelperStore {

    @observable isAuthenticated = false;
    @observable routeTimingsDataTable = "";
    @observable bookingsDataTable = "";
    @observable tripsDataTable = "";
    @observable tripStagingDataTable = "";
    @observable driversDataTable = "";
    @observable vehiclesDataTable = "";
    @observable addRoutetimingModalVisibility = false;
    @observable addVehicleModalVisibility = false;
    @observable addDriverModalVisibility = false;
    @observable collapseState = false;
    @observable currentPageId = null;
    @observable caseDataTable = "";
    @observable currentEndPointRouteSideNav = "";
    @observable transactionsDatatable = "";
    @observable tripRouteHistory = "";
    // @observable tripRoutePolyline = "";

    @action setAuthentication() {
        var is_authenticated = checkAuth.CheckAuth();
        //console.log(is_authenticated);
        this.isAuthenticated = is_authenticated;
    }
    @action removeAuthentication() {

        this.isAuthenticated = false;
    }
 
    @action setSidePanelCollapsed(state) {
        this.collapseState = state;
    }
    @action setCurrentPageId(page_id) {
        CookiesHandler.setCurrentPageId(page_id);
        var c_p_id = CookiesHandler.getCurrentpageId();
        this.currentPageId = c_p_id;
    }

    @action setCurrentEndPointSideNav(end_point){
        this.currentEndPointRouteSideNav = end_point
    }

    @action setRouteTimingsDatatable (data) {
        this.routeTimingsDataTable = data;
    }

    @action setBookingsDatatable (data) {
        this.bookingsDataTable = data;
    }

    @action setTripsDatatable (data) {
        this.tripsDataTable = data;
    }

    @action setDriversDatatable (data) {
        this.driversDataTable = data;
    }

    @action setVehiclesDatatable (data) {
        this.vehiclesDataTable = data;
    }

    @action setRouteTimingModalVisibility(flag){
        this.addRoutetimingModalVisibility = flag
    }

    @action setAddVehicleModalVisibility(flag){
        this.addVehicleModalVisibility = flag
    }

    @action setAddDriverModalVisibility(flag){
        this.addDriverModalVisibility = flag
    }
    @action setTripStagingDatatable (data) {
        this.tripStagingDataTable = data;
    }

    @action setCaseDataTable (data){
        //console.log(data)
        this.caseDataTable = data
    }

    @action setTransactionsDatatable(data){
        this.transactionsDatatable = data
    }

    @action setTripRouteHistory(data){
        this.tripRouteHistory = data
    }

    // @action setTripRoutePolyline(data){
    //     this.tripRoutePolyline = data
    // }




    @computed
    get getIsAuthenticated() {
        // console.log("In Store => Is Authenticated => "+this.isAuthenticated);
        return this.isAuthenticated;
    }
    @computed
    get getSidePanelCollapsed() {
        return this.collapseState;
    }

    @computed
    get getCurrentPageId() {

        return this.currentPageId;
    }
    @computed 
    get getRouteTimingsDataTable(){
        return this.routeTimingsDataTable
    }

    @computed 
    get getBookingsDataTable(){
        return this.bookingsDataTable
    }

    @computed 
    get getTripsDataTable(){
        return this.tripsDataTable
    }

    @computed 
    get getDriversDataTable(){
        return this.driversDataTable
    }

    @computed 
    get getVehiclesDataTable(){
        return this.vehiclesDataTable
    }

    @computed 
    get getRouteTimingModalVisibility(){
        return this.addRoutetimingModalVisibility;
    }

    @computed 
    get getAddVehicleModalVisibility(){
        return this.addVehicleModalVisibility;
    }

    @computed 
    get getAddDriverModalVisibility(){
        return this.addDriverModalVisibility;
    }

    @computed 
    get getTripStagingDataTable(){
        return this.tripStagingDataTable;
    }

    @computed
    get getCaseDataTable(){
        return this.caseDataTable;
    }

    @computed
    get getTransactionsDataTable(){
        return this.transactionsDatatable;
    }

    @computed
    get getTripRouteHistory(){
        return this.tripRouteHistory;
    }

    // @computed
    // get getTripRoutePolyline(){
    //     return this.tripRoutePolyline;
    // }
}





// WEBPACK FOOTER //
// ./src/AppStore/appHelperStore.js